import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

/** A titled panel, styled like the owner's mockup: icon + uppercase title, action at the right. */
export function Card({ title, icon: Icon, actions, children, className, badge }: {
  title: string; icon?: LucideIcon; actions?: ReactNode; children: ReactNode; className?: string; badge?: ReactNode;
}) {
  return (
    <section className={`tc ${className ?? ""}`} aria-label={title}>
      <header className="tc-head">
        <h3>{Icon && <Icon size={20} strokeWidth={1.75} aria-hidden="true" />}{title}{badge}</h3>
        {actions && <div className="tc-actions">{actions}</div>}
      </header>
      {children}
    </section>
  );
}

export function Toggle({ label, checked, onChange, disabled, hint }: {
  label: string; checked: boolean; onChange: (v: boolean) => void; disabled?: boolean; hint?: string;
}) {
  return (
    <label className="toggle" title={hint}>
      <input type="checkbox" role="switch" checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />
      <span className="track" aria-hidden="true"><span className="thumb" /></span>
      <span>{label}</span>
    </label>
  );
}

/** A button for something that needs a connection we have not built yet (email, payments, Shippo…). */
export function Later({ children, why, className, icon: Icon }: { children: ReactNode; why: string; className?: string; icon?: LucideIcon }) {
  return (
    <button type="button" className={`btn ${className ?? "outline"}`} disabled title={`Not connected yet: ${why}`}>
      {Icon && <Icon size={16} aria-hidden="true" />}{children}
    </button>
  );
}

/** Colour family for a status pill. */
export function statusTone(name: string, closed: boolean): string {
  const n = name.toLowerCase();
  if (closed) return "grey";
  if (/ready|resolved|paid|invoiced/.test(n)) return "green";
  if (/waiting|limbo|declined|verify|pending/.test(n)) return "orange";
  return "blue";
}
